export const normalizeAllowedSiteIds = (rawAllowedSiteIds) => {
  if (!Array.isArray(rawAllowedSiteIds)) return [];

  const uniqueIds = new Set();
  rawAllowedSiteIds.forEach((value) => {
    const safeValue = String(value || '').trim();
    if (safeValue) uniqueIds.add(safeValue);
  });

  return Array.from(uniqueIds);
};

export const sanitizeAllowedSiteIds = (rawAllowedSiteIds, availableSites) => {
  const validSiteIds = new Set(
    (Array.isArray(availableSites) ? availableSites : [])
      .map((site) => String(site?.id || '').trim())
      .filter(Boolean)
  );

  return normalizeAllowedSiteIds(rawAllowedSiteIds).filter((siteId) => validSiteIds.has(siteId));
};

export const hasRestrictedSiteAccess = (rawAllowedSiteIds) =>
  normalizeAllowedSiteIds(rawAllowedSiteIds).length > 0;

export const canAccessSiteId = (rawAllowedSiteIds, siteId) => {
  if (!siteId) return true;

  const normalizedIds = normalizeAllowedSiteIds(rawAllowedSiteIds);
  if (normalizedIds.length === 0) return true;

  return normalizedIds.includes(String(siteId));
};
